<template>
    <div :style="!isMobile ? 'width: 400px; margin: 70px auto 0' : ''">

        <v-app-bar v-if="isMobile" app flat dense>
            <sg-logo />
        </v-app-bar>

        <v-main>

            <v-card :class="isMobile ? 'pt-3' : 'py-3'" :min-height="isMobile ? '' : '500px'" :tile="isMobile" :flat="isMobile">
                <sg-logo v-if="!isMobile" class="mb-3 px-3" />
                <slot/>
            </v-card>
        </v-main>

        <v-footer v-if="isMobile" app color="">
            <v-btn text x-small color="grey" @click="goToHelp">Помощь</v-btn>

            <v-spacer />

            <v-btn text x-small color="grey" :to="akbOfferUrl" target="_blank">Оферта</v-btn>
            <v-btn text x-small color="grey" :to="sgEluaUrl" target="_blank">Правила</v-btn>

        </v-footer>

        <div v-else class="d-flex justify-end mt-2">
            <v-btn text color="primary" class="text-none" @click="goToHelp">Помощь</v-btn>
            <v-spacer />
            <v-btn text color="primary" class="text-none" :to="akbOfferUrl" target="_blank">Оферта</v-btn>
            <v-btn text color="primary" class="text-none" :to="sgEluaUrl" target="_blank">Правила</v-btn>

        </div>


    </div>
</template>

<script>
    import SgLogo from '@/components/SgLogo'

    export default {

        components: {
            SgLogo
        },

        computed: {

        },
        data() {
            return {
                akbOfferUrl: 'https://lk.sistemagorod.ru/lk/away?to=http%3a%2f%2fcapitalbank.ru%2fchastnym-klientam%2fplastikovye-karty%2fvirt-platezi%2foferta%2f',
                sgEluaUrl: 'https://lk.sistemagorod.ru/lk/away?to=http%3a%2f%2fwww.sistemagorod.ru%2frules%2fPRAVILA_01_04_2016.pdf'
            }
        },

        methods: {
            goToHelp() {
                this.$router.push({
                    name: 'quick-pay-support'
                })
            }
        },

    }
</script>

<style>

</style>